import React, { useState } from "react";

const PremiumThemesPage = () => {
  const [selectedCategory, setSelectedCategory] = useState("All");

  const themes = [
    {
      id: 1,
      title: "Modern Business Pro",
      price: 3500,
      originalPrice: 5000,
      totalSales: 245,
      category: "Business",
      image:
        "https://images.unsplash.com/photo-1460925895917-afdab827c52f?w=400&h=250&fit=crop",
      description:
        "Professional business theme with modern design and responsive layout",
      features: [
        "Responsive Design",
        "SEO Optimized",
        "Contact Forms",
        "Portfolio Section",
      ],
    },
    {
      id: 2,
      title: "E-Commerce Elite",
      price: 4500,
      originalPrice: 6500,
      totalSales: 189,
      category: "E-commerce",
      image:
        "https://images.unsplash.com/photo-1556742049-0cfed4f6a45d?w=400&h=250&fit=crop",
      description:
        "Complete e-commerce solution with shopping cart and payment integration",
      features: [
        "Shopping Cart",
        "Payment Gateway",
        "Product Management",
        "User Accounts",
      ],
    },
    {
      id: 3,
      title: "Creative Portfolio",
      price: 2800,
      originalPrice: 4000,
      totalSales: 312,
      category: "Portfolio",
      image:
        "https://images.unsplash.com/photo-1561070791-2526d30994b5?w=400&h=250&fit=crop",
      description:
        "Stunning portfolio theme perfect for designers and creative professionals",
      features: [
        "Gallery System",
        "Animation Effects",
        "Blog Integration",
        "Client Testimonials",
      ],
    },
    {
      id: 4,
      title: "Restaurant Deluxe",
      price: 3200,
      originalPrice: 4800,
      totalSales: 156,
      category: "Restaurant",
      image:
        "https://images.unsplash.com/photo-1517248135467-4c7edcad34c4?w=400&h=250&fit=crop",
      description:
        "Elegant restaurant theme with menu management and reservation system",
      features: [
        "Menu Display",
        "Online Reservations",
        "Location Maps",
        "Social Media",
      ],
    },
    {
      id: 5,
      title: "Tech Startup",
      price: 4000,
      originalPrice: 5500,
      totalSales: 198,
      category: "Technology",
      image:
        "https://images.unsplash.com/photo-1551650975-87deedd944c3?w=400&h=250&fit=crop",
      description:
        "Modern tech startup theme with innovative design and advanced features",
      features: [
        "Landing Pages",
        "App Showcase",
        "Team Profiles",
        "Pricing Tables",
      ],
    },
    {
      id: 6,
      title: "Medical Care Pro",
      price: 3800,
      originalPrice: 5200,
      totalSales: 134,
      category: "Healthcare",
      image:
        "https://images.unsplash.com/photo-1559757148-5c350d0d3c56?w=400&h=250&fit=crop",
      description:
        "Professional healthcare theme with appointment booking and patient portal",
      features: [
        "Appointment System",
        "Doctor Profiles",
        "Service Pages",
        "Patient Portal",
      ],
    },
    {
      id: 7,
      title: "Education Hub",
      price: 3600,
      originalPrice: 5000,
      totalSales: 221,
      category: "Education",
      image:
        "https://images.unsplash.com/photo-1522202176988-66273c2fd55f?w=400&h=250&fit=crop",
      description:
        "Comprehensive education theme with course management and student portal",
      features: [
        "Course Catalog",
        "Student Dashboard",
        "Online Learning",
        "Progress Tracking",
      ],
    },
    {
      id: 11,
      title: "Nextjs Multi Purpose Admin  Dashboard",
      price: 6150,
      originalPrice: 9500,
      totalSales: 62,
      category: "Generic",
      image: "/assets/images/nextdashboard.PNG",
      description: "IT Solutions & Generic  Next Js Template",
      features: [
        "110+ Pages",
        "UI Components",
        "Multiple Layouts",
        "Dark & Light Mode",
      ],
    },
    {
      id: 8,
      title: "Fashion Store",
      price: 4200,
      originalPrice: 6000,
      totalSales: 167,
      category: "Fashion",
      image:
        "https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=400&h=250&fit=crop",
      description:
        "Trendy fashion e-commerce theme with style and functionality",
      features: ["Product Showcase", "Size Charts", "Wishlist", "Style Guide"],
    },
    {
      id: 9,
      title: "Real Estate Pro",
      price: 4800,
      originalPrice: 6800,
      totalSales: 142,
      category: "Real Estate",
      image:
        "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=400&h=250&fit=crop",
      description:
        "Professional real estate theme with property listings and search functionality",
      features: [
        "Property Search",
        "Virtual Tours",
        "Agent Profiles",
        "Mortgage Calculator",
      ],
    },
    {
      id: 10,
      title: "Multi Purpose",
      price: 9500,
      originalPrice: 12500,
      totalSales: 182,
      category: "Generic",
      image: "/assets/images/it-theme.PNG",
      description: "IT Solutions & Services React Next Js Template",
      features: ["12 Homepage Demos", "Creative and Unique Design"],
    },
  ];

  const categories = [
    "All",
    "Business",
    "E-commerce",
    "Portfolio",
    "Restaurant",
    "Technology",
    "Healthcare",
    "Education",
    "Fashion",
    "Real Estate",
  ];

  const filteredThemes =
    selectedCategory === "All"
      ? themes
      : themes.filter((theme) => theme.category === selectedCategory);

  const handleWhatsAppClick = (themeName) => {
    const message = encodeURIComponent(
      `Hi! I'm interested in purchasing the "${themeName}" theme. Could you please provide more details about the installation and customization process?`
    );
    window.open(`https://wa.me/+923124998010?text=${message}`, "_blank");
  };

  return (
    <div
      style={{ fontFamily: "Arial, sans-serif", backgroundColor: "#f8f9fa" }}
    >
      {/* Header Section */}
      <header
        style={{
          background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
          color: "white",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h1
                style={{
                  fontSize: "3rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Premium Themes Collection
              </h1>
              <p
                style={{
                  fontSize: "1.2rem",
                  opacity: 0.9,
                  maxWidth: "600px",
                  margin: "0 auto",
                }}
              >
                Discover our handcrafted premium themes designed to elevate your
                online presence. Professional, responsive, and fully
                customizable.
              </p>
            </div>
          </div>
        </div>
      </header>

      {/* Stats Section */}
      <section style={{ backgroundColor: "white", padding: "60px 0" }}>
        <div className="container">
          <div className="row text-center">
            <div className="col-md-3 col-sm-6 mb-4">
              <div style={{ padding: "20px" }}>
                <h3
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    color: "#667eea",
                    marginBottom: "10px",
                  }}
                >
                  50+
                </h3>
                <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
                  Premium Themes
                </p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div style={{ padding: "20px" }}>
                <h3
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    color: "#28a745",
                    marginBottom: "10px",
                  }}
                >
                  2000+
                </h3>
                <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
                  Happy Customers
                </p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div style={{ padding: "20px" }}>
                <h3
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    color: "#ffc107",
                    marginBottom: "10px",
                  }}
                >
                  24/7
                </h3>
                <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
                  Support Available
                </p>
              </div>
            </div>
            <div className="col-md-3 col-sm-6 mb-4">
              <div style={{ padding: "20px" }}>
                <h3
                  style={{
                    fontSize: "2.5rem",
                    fontWeight: "bold",
                    color: "#dc3545",
                    marginBottom: "10px",
                  }}
                >
                  100%
                </h3>
                <p style={{ color: "#6c757d", fontSize: "1.1rem" }}>
                  Money Back Guarantee
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Filter Section */}
      <section style={{ backgroundColor: "#f8f9fa", padding: "40px 0" }}>
        <div className="container">
          <div className="row">
            <div className="col-12 text-center">
              <h2
                style={{
                  fontSize: "2rem",
                  fontWeight: "bold",
                  color: "#2c3e50",
                  marginBottom: "30px",
                }}
              >
                Browse by Category
              </h2>
              <div className="d-flex flex-wrap justify-content-center gap-2">
                {categories.map((category) => (
                  <button
                    key={category}
                    className={`btn ${
                      selectedCategory === category
                        ? "btn-primary"
                        : "btn-outline-primary text-dark"
                    }`}
                    onClick={() => setSelectedCategory(category)}
                    style={{
                      padding: "8px 20px",
                      margin: "5px",
                      borderRadius: "25px",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {category}
                  </button>
                ))}
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Themes Grid */}
      <section style={{ padding: "80px 0" }}>
        <div className="container">
          <div className="row">
            {filteredThemes.map((theme) => (
              <div key={theme.id} className="col-lg-4 col-md-6 mb-4">
                <div
                  className="card h-100"
                  style={{
                    boxShadow: "0 5px 15px rgba(0,0,0,0.1)",
                    border: "none",
                    borderRadius: "15px",
                    overflow: "hidden",
                    transition: "all 0.3s ease",
                  }}
                  onMouseOver={(e) => {
                    e.currentTarget.style.transform = "translateY(-5px)";
                    e.currentTarget.style.boxShadow =
                      "0 10px 25px rgba(0,0,0,0.2)";
                  }}
                  onMouseOut={(e) => {
                    e.currentTarget.style.transform = "translateY(0)";
                    e.currentTarget.style.boxShadow =
                      "0 5px 15px rgba(0,0,0,0.1)";
                  }}
                >
                  {/* Theme Image */}
                  <div style={{ position: "relative" }}>
                    <img
                      src={theme.image}
                      alt={theme.title}
                      style={{
                        width: "100%",
                        height: "200px",
                        objectFit: "cover",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        top: "10px",
                        right: "10px",
                        backgroundColor:
                          theme.category === "Business"
                            ? "#007bff"
                            : theme.category === "E-commerce"
                            ? "#28a745"
                            : theme.category === "Portfolio"
                            ? "#6f42c1"
                            : theme.category === "Restaurant"
                            ? "#fd7e14"
                            : theme.category === "Technology"
                            ? "#17a2b8"
                            : theme.category === "Healthcare"
                            ? "#dc3545"
                            : theme.category === "Education"
                            ? "#ffc107"
                            : theme.category === "Fashion"
                            ? "#e83e8c"
                            : "#6c757d",
                        color: "white",
                        padding: "5px 10px",
                        borderRadius: "15px",
                        fontSize: "0.8rem",
                        fontWeight: "bold",
                      }}
                    >
                      {theme.category}
                    </div>
                  </div>

                  <div className="card-body d-flex flex-column">
                    <h5
                      style={{
                        fontSize: "1.3rem",
                        fontWeight: "bold",
                        color: "#2c3e50",
                        marginBottom: "10px",
                      }}
                    >
                      {theme.title}
                    </h5>

                    <p
                      style={{
                        color: "#6c757d",
                        fontSize: "0.9rem",
                        marginBottom: "15px",
                        lineHeight: "1.5",
                      }}
                    >
                      {theme.description}
                    </p>

                    {/* Features */}
                    <div style={{ marginBottom: "15px" }}>
                      <div className="d-flex flex-wrap gap-1">
                        {theme.features.slice(0, 4).map((feature, index) => (
                          <span
                            key={index}
                            style={{
                              backgroundColor: "#e9ecef",
                              color: "#495057",
                              padding: "2px 8px",
                              borderRadius: "10px",
                              fontSize: "0.75rem",
                              fontWeight: "500",
                            }}
                          >
                            {feature}
                          </span>
                        ))}
                      </div>
                    </div>

                    {/* Price and Sales */}
                    <div style={{ marginBottom: "15px" }}>
                      <div className="d-flex align-items-center justify-content-between">
                        <div>
                          <span
                            style={{
                              fontSize: "0.9rem",
                              color: "#6c757d",
                              textDecoration: "line-through",
                            }}
                          >
                            PKR {theme.originalPrice.toLocaleString()}
                          </span>
                          <br />
                          <span
                            style={{
                              fontSize: "1.5rem",
                              fontWeight: "bold",
                              color: "#e74c3c",
                            }}
                          >
                            PKR {theme.price.toLocaleString()}
                          </span>
                        </div>
                        <div className="text-end">
                          <div
                            style={{
                              backgroundColor: "#28a745",
                              color: "white",
                              padding: "5px 10px",
                              borderRadius: "15px",
                              fontSize: "0.8rem",
                              fontWeight: "bold",
                            }}
                          >
                            {theme.totalSales} Sales
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Purchase Button */}
                    <button
                      className="btn btn-primary btn-lg w-100 mt-auto"
                      onClick={() => handleWhatsAppClick(theme.title)}
                      style={{
                        fontWeight: "bold",
                        padding: "12px",
                        fontSize: "1rem",
                        borderRadius: "10px",
                        background: "linear-gradient(45deg, #667eea, #764ba2)",
                        border: "none",
                        transition: "all 0.3s ease",
                      }}
                      onMouseOver={(e) => {
                        e.target.style.transform = "translateY(-2px)";
                        e.target.style.boxShadow =
                          "0 5px 15px rgba(102, 126, 234, 0.4)";
                      }}
                      onMouseOut={(e) => {
                        e.target.style.transform = "translateY(0)";
                        e.target.style.boxShadow = "none";
                      }}
                    >
                      💬 Purchase via WhatsApp
                    </button>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Why Choose Our Themes */}
      <section
        style={{
          backgroundColor: "#2c3e50",
          color: "white",
          padding: "80px 0",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12 text-center mb-5">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Why Choose Our Premium Themes?
              </h2>
            </div>
          </div>

          <div className="row">
            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(52, 152, 219, 0.2)",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "2rem",
                }}
              >
                📱
              </div>
              <h4 style={{ marginBottom: "15px" }}>Fully Responsive</h4>
              <p style={{ opacity: 0.9 }}>
                All themes are mobile-friendly and work perfectly on all devices
                and screen sizes.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(46, 204, 113, 0.2)",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "2rem",
                }}
              >
                🎨
              </div>
              <h4 style={{ marginBottom: "15px" }}>Easy Customization</h4>
              <p style={{ opacity: 0.9 }}>
                Customize colors, fonts, and layouts easily without any coding
                knowledge required.
              </p>
            </div>

            <div className="col-md-4 text-center mb-4">
              <div
                style={{
                  backgroundColor: "rgba(243, 156, 18, 0.2)",
                  width: "80px",
                  height: "80px",
                  borderRadius: "50%",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  margin: "0 auto 20px",
                  fontSize: "2rem",
                }}
              >
                🚀
              </div>
              <h4 style={{ marginBottom: "15px" }}>SEO Optimized</h4>
              <p style={{ opacity: 0.9 }}>
                Built with SEO best practices to help your website rank higher
                in search engines.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Call to Action */}
      <section
        style={{
          background: "linear-gradient(135deg, #f093fb 0%, #f5576c 100%)",
          color: "white",
          padding: "80px 0",
          textAlign: "center",
        }}
      >
        <div className="container">
          <div className="row">
            <div className="col-12">
              <h2
                style={{
                  fontSize: "2.5rem",
                  fontWeight: "bold",
                  marginBottom: "20px",
                }}
              >
                Need Help Choosing?
              </h2>
              <p
                style={{
                  fontSize: "1.2rem",
                  opacity: 0.9,
                  marginBottom: "30px",
                  maxWidth: "600px",
                  margin: "0 auto 30px",
                }}
              >
                Our team is ready to help you find the perfect theme for your
                project. Contact us for personalized recommendations!
              </p>

              <button
                className="btn btn-light btn-lg"
                onClick={() => handleWhatsAppClick("Theme Consultation")}
                style={{
                  fontWeight: "bold",
                  padding: "15px 30px",
                  fontSize: "1.1rem",
                  color: "#f5576c",
                  border: "none",
                  borderRadius: "25px",
                  boxShadow: "0 4px 15px rgba(0,0,0,0.2)",
                }}
              >
                💬 Get Free Consultation
              </button>
            </div>
          </div>
        </div>
      </section>

      {/* Bootstrap CSS */}
      <link
        href="https://cdnjs.cloudflare.com/ajax/libs/bootstrap/5.3.0/css/bootstrap.min.css"
        rel="stylesheet"
      />
    </div>
  );
};

export default PremiumThemesPage;
